import { inject, Injectable } from '@angular/core';
import { GenericCheckoutService } from './generic-checkout.service';
import { AddressType, CheckoutTabNames } from '../enums';
import { BehaviorSubject, Observable } from 'rxjs';
import { CheckoutTab, CheckoutTabsDisabled, ItemInventoryType, SaveAddressDto, UserAddress } from '../models';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NgxAimService } from '../ngx-aim.service';

@Injectable({
  providedIn: 'root'
})
export class MakePaymentCheckoutService extends GenericCheckoutService {
  ngxAimService = inject(NgxAimService);
  http = inject(HttpClient);

  private baseUrl = this.ngxAimService.getApiUrl();

  public tabs: CheckoutTab[] = [];

  private tabIndexSubject = new BehaviorSubject<number>(0);
  public tabIndex$ = this.tabIndexSubject.asObservable();
  public setTabIndex(index: number) {
    this.tabIndexSubject.next(index);
  }
  public setTabIndexByHeader(header: CheckoutTabNames) {
    const tab = this.tabs.find((tab) => tab.header === header);
    if (tab) {
      this.tabIndexSubject.next(tab.index);
    } else {
      console.error(`unable to find tab header: ${header}`);
    }
  }

  private tabsDisabledSubject = new BehaviorSubject<CheckoutTabsDisabled>({
    [CheckoutTabNames.BILLING_ADDRESS]: false,
    [CheckoutTabNames.PAYMENT]: true,
  });
  public tabsDisabed$ = this.tabsDisabledSubject.asObservable();
  public setTabIsDisabled(tabIndex: CheckoutTabNames, isDisabled: boolean) {
    const tabs = this.tabsDisabledSubject.value;
    tabs[tabIndex] = isDisabled;
    this.tabsDisabledSubject.next(tabs);
  }

  private userBillingAddressSubject = new BehaviorSubject<Partial<SaveAddressDto>>({});
  public userBillingAddress$ = this.userBillingAddressSubject.asObservable();
  public getUserBillingAddress() {
    return this.userBillingAddressSubject.value;
  }

  getAddress(type: AddressType): Observable<UserAddress> {
    return this.http.get<UserAddress>(`${this.baseUrl}/users/get-address`, {
      params: new HttpParams()
        .set('type', type)
    });
  }

  saveAddress(address: SaveAddressDto): Observable<void> {
    this.userBillingAddressSubject.next(address);
    return this.http.post<void>(`${this.baseUrl}/users/save-address`, address);
  }

  public reset() {
    this.tabIndexSubject.next(0);
    this.tabsDisabledSubject.next({
      [CheckoutTabNames.BILLING_ADDRESS]: true,
      [CheckoutTabNames.PAYMENT]: true,
    });
  }

  emitGaAddPaymentInfo(): void {}

  emitGaAddShippingInfo(): void {}

  getDeliveryOptions(itemType: ItemInventoryType): void {}

  updateTotals(): void {}
}
